import { FlagSvg, TrophyBlack } from "assets/images/common/svgs";
import DataNotFound from "components/particles/table/data-not-found";
import useUsers from "containers/user-management/useHooks";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
interface Props {
  ambassadorId: number;
}

const Activities = ({ ambassadorId }: Props) => {
  const { getActivities } = useUsers();
  const [data, setData] = useState<any[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const loadActivitiesPoints = async (pageToLoad: number = 0) => {
    if (!ambassadorId) return;

    await getActivities(
      setData,
      {
        page: pageToLoad,
        size: 5,
        ambassadorId: ambassadorId,
      },
      pageToLoad,
      setHasMore
    );
    setPage(pageToLoad + 1);
  };

  useEffect(() => {
    if (ambassadorId) {
      // Reset when ambassadorId changes
      setData([]);
      setPage(0);
      setHasMore(false);
      loadActivitiesPoints(0);
    }
  }, [ambassadorId]);

  const handleLoadMore = () => {
    loadActivitiesPoints(page);
  };


  return (
    <div>

      <div className="flex flex-wrap items-center gap-6">
        {data.map((item, index) => (
          <div
            key={index}
            className="border border-stokeLight rounded-[15px] p-6 flex flex-col items-center justify-center gap-2 text-center h-[126px] w-[190px]"
          >
            <div className="flex flex-col gap-2 items-center justify-center">
              <span>
                <TrophyBlack />
              </span>
              <span className="text-xs font-bold text-black">
                {item?.activity}
              </span>
              <span className="text-sm text-goldenAmberText font-bold">
                {item?.pointsEarned} pts
              </span>
              <span className="text-xs text-primaryText">
                {item?.createdAt
                  ? new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(new Date(item?.createdAt))
                  : "-"}
              </span>
              {/* <div className="w-full mt-1">
                <div className="h-[4px] w-full bg-ghostGrayBg rounded-full">
                  <div
                    className="h-full bg-goldenOrangeBg rounded-full"
                    style={{ width: "82%" }}
                  ></div>
                </div>
                <span className="text-[10px] font-medium text-black">
                  82/100 pts
                </span>
              </div> */}
            </div>
          </div>
        ))}
      </div>

      {!isLoading && data.length > 0 && hasMore && (
        <div className="flex justify-center mt-4">
          <button
            onClick={handleLoadMore}
            className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
          >
            See More
          </button>
        </div>
      )}


      <div className="">
        <DataNotFound show={!isLoading && !data.length} />
      </div>
    </div>
  );
};

export default Activities;
